export const inputCls =
  "w-full rounded-xl border border-subtle bg-surface px-4 py-3.5 text-sm text-ink outline-none transition-colors focus:border-blue placeholder:text-faint/60";

export const labelCls = "mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-faint";

export const SERVICE_ALIASES = {
  "home-cleaning": "regular",
  "deep-cleaning": "deep",
  "property-cleaning": "airbnb",
};

export function gbp(value) {
  const n = Number(value || 0);
  return `£${n.toLocaleString("en-GB", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
}

export function londonDate(offsetDays = 0) {
  const d = new Date(Date.now() + offsetDays * 86400000);
  return d.toLocaleDateString("en-CA", { timeZone: "Europe/London" });
}

export function formatDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
}

export function computeQuote(catalog, form) {
  const service = catalog?.services.find((s) => s.slug === form.service_slug);
  const property = service?.properties.find((p) => p.key === form.property_key);
  const included = service?.included_extras || [];
  const extras = (catalog?.extras || []).filter((e) => form.extras.includes(e.key) && !included.includes(e.key));
  const base = property?.price || 0;
  const extrasTotal = extras.reduce((sum, e) => sum + e.price, 0);
  return { service, property, extras, base, extrasTotal, total: property ? base + extrasTotal : 0 };
}
